module.exports = __webpack_public_path__ + "img/人行配置.72eae1fc.svg";